import { TaskItem } from '@/types/task';
import { computed } from '@vue/composition-api';
import Decimal from 'decimal.js';
export const useTaskStampCount = (taskInfo: TaskItem) => {
  const stampCnt = computed(() => {
    const { maxTimesPerStage, prizeCountPerTime } = taskInfo;
    return new Decimal(maxTimesPerStage).mul(prizeCountPerTime);
  });
  return {
    stampCnt,
  };
};
